"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWrapper = _interopRequireDefault(require("../withWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _withWrapper.default)('Cutting', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(6.000000, 5.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("g", {
    transform: "translate(0.000000, 0.021632)"
  }, _react.default.createElement("polyline", {
    points: "0 4.97836848 32 4.97836848 32 36.9783685"
  }), _react.default.createElement("path", {
    d: "M20.4664367,-6 L20.4664367,39.0238636",
    transform: "\n                                translate(20.466437, 16.511932) rotate(-135.000000) translate(-20.466437, -16.511932)\n                            "
  }), _react.default.createElement("polyline", {
    transform: "translate(20.000000, 16.978368) scale(-1, -1) translate(-20.000000, -16.978368)",
    points: "4 0.978368479 36 0.978368479 36 32.9783685"
  })))));
});

exports.default = _default;